<template>
  <div style="overflow: hidden">
    <div class="generate-poster">
      <div class="room-list">
        <h5 class="ver-title">直播间列表</h5>
        <div v-for="(item, index) in rooms" :key="index" class="room-item">
          <img :src="item.posterImage | filterPicture" />
          <div class="item-info">
            <div style="width: 100%">
              <h5 style="font-size: 16px; overflow: hidden">{{ item.name }}</h5>
              <h5 v-if="item.whetherExpand" style="margin-top: 6px; font-size: 12px; color: #AAA">已推广 {{ item.expandNums || 0 }} 人</h5>
              <h5 v-else style="margin-top: 6px; font-size: 12px; color: #AAA">暂未推广</h5>
            </div>
            
            <van-button @click="showForm(item)" type="info" size="small">生成海报</van-button>
          </div>
        </div>
      </div>
    </div>

    <div class="poster" ref="userPoster">
      <img v-if="posterBg" :src="posterBg | filterOriginPicture" :style="{ 'width': posterWidth + 'px', 'height': posterHeight + 'px' }" class="poster-bg" />
      <div class="qrcode-box" :style="{ 'right': (posterWidth / 750 * 40) + 'px', 'bottom': (posterHeight / 1334 * 130) + 'px' }">
        <div v-if="changeCode" class="qrcode" ref="qrCodeUrl" :style="{ 'padding': (posterWidth / 750 * 5) + 'px', 'width': (posterWidth / 750 * 180) + 'px', 'height': (posterWidth / 750 * 180) + 'px' }" />
      </div>
      <div class="user-info" :style="{ 'left': (posterWidth / 750 * 55) + 'px', 'bottom': (posterHeight / 1334 * 180) + 'px' }">
        <img :style="{ 'width': (posterWidth / 750 * 110) + 'px', 'height': (posterWidth / 750 * 110) + 'px' }" class="avatar" :src="user.avatar | filterOriginPicture" />
        <div class="card" :style="{ 'margin-left': (posterWidth / 750 * 25) + 'px' }">
          <h4 :style="{ 'font-size': (posterWidth / 750 * 34) + 'px' }">{{ name }}</h4>
          <h4 :style="{ 'margin-top': (posterHeight / 1334 * 10) + 'px', 'font-size': (posterWidth / 750 * 28) + 'px' }">{{ mobile }}</h4>
        </div>
      </div>
    </div>

    <van-overlay :show="popupVisible" @click="popupVisible = false">
      <img @click="() => {}" class="download-poster" ref="downloadPoster" />
    </van-overlay>

    <van-overlay :show="infoVisible" @click="infoVisible = false">
      <div @click.stop="() => {}" class="poster-form">
        <van-field label-width="80" v-model="name" label="姓名"  placeholder="姓名" />
        <van-field label-width="80" v-model="mobile" label="手机号"  placeholder="手机号" type="number" />

        <div style="margin: 30px 20px 0;">
          <van-button size="normal" @click="generatePoster" block type="primary" :disabled="!name">一键生成专属海报</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      rooms: [],
      roomId: '',

      posterBg: null,
      posterWidth: 750,
      posterHeight: 1334,

      name: '',
      mobile: '',
      infoVisible: false,
      popupVisible: false,
      changeCode: false,

      selectedCity: null,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.user
    })
  },

  created () {
    window.document.title = '生成推广海报'
    this.toast.loading({ duration: 0, message: '', forbidClick: true })

    this.initPoster()
  },

  methods: {
    initPoster () {
      this.request({
        url: '/liveRoom/listByExpand',
        data: { limit: 100, status: 'READY' },
      }).then(res => {
        this.loading = false
        this.toast.clear()

        this.rooms = res.result.rows.filter(item => item.name.indexOf('测试') === -1)
      })

      const innerWidth = window.innerWidth
      const innerHeight = window.innerHeight

      if (innerWidth / innerHeight > 9 / 16) {
        this.posterHeight = innerHeight
        this.posterWidth = innerHeight * 9 / 16
      } else {
        this.posterWidth = innerWidth
        this.posterHeight = innerWidth / 9 * 16
      }

      this.name = this.user.realName
      this.mobile = this.user.mobile
    },

    // initCanvas () {
    //   html2canvas(this.$refs.userPoster, {
    //     width: this.posterWidth,
    //     height: this.posterHeight
    //   }).then((canvas) => {
    //     canvas.toDataURL('image/png')
    //   })
    // },

    showForm (room) {
      this.roomId = room.id
      this.posterBg = room.posterImage
      this.infoVisible = true
    },

    onCitiesConfirm (row) {
      this.selectedCity = row
    },

    generatePoster () {
      if (this.area.id === 'south' && !this.selectedCity) {
        return this.toast('请先选择城市公司')
      }

      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      if (!this.changeCode) {
        this.changeCode = true
      }

      var form = {
        liveRoomId: this.roomId,
        memberMobile: this.mobile,
        memberName: this.name
      }

      if (this.selectedCity) form.belongto = this.selectedCity.val

      this.request({ url: '/liveExpand/add', data: form }).then(codeRes => {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: window.location.origin + '/dg3/room/' + this.roomId + '-' + codeRes.result,
          width: this.posterWidth / 750 * 170,
          height: this.posterWidth / 750 * 170,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })

        this.infoVisible = false

        setTimeout(() => {
          html2canvas(this.$refs.userPoster, {
            allowTaint: false,
            useCORS: true,
            width: this.posterWidth,
            height: this.posterHeight
          }).then((canvas) => {
            this.toast.clear()
            let downloadImage = this.$refs.downloadPoster
            downloadImage.src = canvas.toDataURL('image/png')

            setTimeout(() => {
              this.changeCode = false
              this.popupVisible = true
              this.toast('长按保存海报至本地相册')
            }, 400)
          })
        }, 200)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.poster {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  .poster-bg {
    display: block;
  }
  .user-info {
    position: absolute;
    display: flex;
    .avatar {
      border-radius: 50%;
    }
    .card {
      display: flex;
      flex-direction: column;
      color: #FFF;
    }
  }
  .qrcode-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    .qrcode {
      background-color: #FFF;
    }
    .qrcode-desc {
      display: flex;
      align-items: center;
      color: #FFF;
    }
  }
}

.generate-poster {
  width: 100%;
  height: 100vh;
  background-color: #F0F0F0;
  overflow-y: scroll;
  .room-list {
    width: 100%;
    .room-item {
      display: flex;
      margin-top: 10px;
      padding: 10px 20px;
      background: #FFF;
      img {
        width: 100px;
        height: 100px;
        border-radius: 4px;
        object-fit: cover;
      }
      .item-info {
        margin-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        flex: 1;
        h5 {
          width: 100%;
        }
      }
    }
  }

  .ver-title {
    padding: 20px 20px 10px;
    font-size: 16px;
    color: #999;
  }
}

.download-poster {
  width: 75%;
  border-radius: 6px;
}

.genrate-btn {
  margin-top: 30px;
  height: 40px;
  width: 250px;
}

.poster-form {
  padding: 40px 0;
  width: 75%; 
  background: #F0F0F0; 
  border-radius: 10px; 
  .van-field, .select {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 48px;
    background-color: #FFF;
  }
  .van-cell__title span, .select-title {
    width: 80px;
    font-size: 14px;
    color: #323233;
  }
  .select-val {
    flex: 1;
  }
  .select-more {
    margin-left: .14rem;
    width: .16rem;
  }
}
</style>